export const getDeliveryBasket = state => state.addToDeliveryCart.deliveryBasket;
export const getError = state => state.addToDeliveryCart.error;
